module.exports = __webpack_public_path__ + "img/museo_cover.be1879fe.png";